import { Link } from 'react-router-dom';

/** Same asset as Bid-Master-Mobile `assets/ic_launcher.png` (copied to `public/bidmaster-icon.png`). */
const ICON_SRC = '/bidmaster-icon.png';

type BidMasterLogoProps = {
  /** Use `false` for a non-clickable mark (e.g. app bar). Default `/` for marketing header. */
  href?: string | false;
  showText?: boolean;
  /** Overrides default wordmark classes. */
  textClassName?: string;
  className?: string;
};

export function BidMasterLogo({
  href = '/',
  showText = true,
  textClassName = 'font-black text-blue-600 tracking-tight text-xl sm:text-[22px] leading-none',
  className = '',
}: BidMasterLogoProps) {
  const inner = (
    <>
      <img
        src={ICON_SRC}
        alt={showText ? '' : 'BidMaster'}
        width={36}
        height={36}
        className="w-9 h-9 rounded-lg object-contain shrink-0"
        decoding="async"
      />
      {showText ? <span className={textClassName}>BidMaster</span> : null}
    </>
  );

  const rowClass = `flex items-center gap-2.5 ${className}`;

  if (href === false) {
    return <div className={rowClass}>{inner}</div>;
  }

  return (
    <Link to={href} className={rowClass}>
      {inner}
    </Link>
  );
}
